<script>
  const { VUE_APP_API_HOST } = process.env 
  import store from './../../store/index.js';

  export default {
    computed: {
      '$dash': () => this.$root.$children[0].$children[0],
    },
    data() {
      return {}
    },
    methods: {
      /**
       * Ready-to-use catcher for server requests
       * @param {Error} error - An error-like object
       * @param {Object} options - Options to modify function behaviour
       */
      handleError(error, options = {}) {
        if ('body' in error) {
          error = error.body
        }

        // Define options
        const opt = { medium: 'notification', ...options }

        // Define standard error object
        const err = {
          // TODO lokalize
          // We could send another key from server, holding lokalise key
          title: this.$t('dash.notifications.error_title'),
          text: this.$t(error.error),    // For Vuesax notifications
          message: this.$t(error.error), // For dashboard dialog
          show: true
        }

        // Display according to 'medium' option
        switch (opt.medium) {
        case 'notification':
          this.$vs.notify(err)
          break
        case 'dialog':
        default:
          this.$dash.dialog = err
          break
        }
      },

      /**
       * Ready-to-use catcher for server requests
       * @param {Error} error - An error-like object
       * @param {Object} options - Options to modify function behaviour
       */
      handleDialogError(error, options = {}) {
        if ('body' in error) {
          error = error.body
        }

        let errorText = this.$t(error.error)
        if(error[0] && error[0].reason)
          errorText += " : " + this.$t(error[0].reason.exception)

        this.$vs.dialog({
          color: 'success',
          title: this.$t('dash.notifications.error_title'),
          text: errorText,
          acceptText: "OK"
        })
      },

      /**
       * Curried variant of `handleError`, with reversed arguments
       * @param {Object} options - The options provided to `handleError`
       * @returns {Function} - `handleError`, with options already filled
       */
      genErrorHandler(options) {
        return err => this.handleError(err, options)
      },

      addLog(user, type, data) {
        if (typeof data === 'object') {
          data = JSON.stringify(data)
        }
        if (!user) {
          user = this.$store.getters['users/currentUser']
        }
        return this.$http
          .post(`${VUE_APP_API_HOST}/log`, {user, type, data}, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          })
          .then(res => res, err => err)
      },

      objectToArray(obj) {
        let keys = Object.keys(obj)
        return Object.values(obj).map((value,i) => { 
          return {
            name: keys[i],
            value
          }
        })
      }
    }
  }
</script>
